export default __webpack_public_path__ + "static/media/JARNIGON_Axel_CV.427fdb96.pdf";